import { useContext, useState } from 'react';
import "./style/profile.css";
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../contextApi/ContextApi';
import { media } from '../../dataSets/media';

export default function Profile({isDashboard}) {
    const { connected, setConnected, currentUser, currentUserUID, setCurrentUser, currentWebsite, primary_color, accent_color, isBelong } = useContext(AppContext);
    const [btnHover, setBtnHover] = useState(false);
    const nav = useNavigate();

    return (
        <div className='profile_container'>
            {!isDashboard&&connected&&isBelong ? 
                <div className="connected_profile">
                    <div className="profile_details">
                        <div className="profile_name" style={{color:accent_color, textShadow:`2px 2px 3px ${primary_color}`,fontSize:"18px"}}>{currentUser?.name}</div>
                        <button className='logoutBtn' style={{color:!btnHover ? primary_color : accent_color, textShadow:`2px 2px 3px ${!btnHover ? accent_color : primary_color}`}} onMouseEnter={()=>{setBtnHover(true)}} onMouseLeave={()=>{setBtnHover(false)}} onClick={()=>{setConnected(false); setCurrentUser(null); nav(`/${currentWebsite?.settings?.domain}/`)}}>התנתק</button>
                    </div>
                    <img className='profile_image' src={media.def_logo} alt="profile-logo" onClick={()=>{nav(`/${currentWebsite?.settings?.domain}/${currentUserUID}/profile/`)}}/>
                </div> :
                <div className='disconnected_profile'>
                    <button className='loginBtn' style={{color:!btnHover ? primary_color : accent_color, textShadow:`2px 2px 3px ${!btnHover ? accent_color : primary_color}`}} onMouseEnter={()=>{setBtnHover(true)}} onMouseLeave={()=>{setBtnHover(false)}} onClick={()=>{isDashboard ? alert("לחצן זה מעביר את הלקוח לעמוד התחברות/הרשמה") : nav(`/${currentWebsite?.settings?.domain}/signin`);}}>להתחברות לחץ כאן</button>
                </div>
            }
        </div>
    )
}
